import React, { useEffect } from 'react'
import { Sidebar, useSidebarState } from 'react-admin'
import MyMenu from './menu'

const CustomSidebar = (props) => {
  const [open] = useSidebarState()

  useEffect(() => {
    const styleId = 'custom-sidebar-style'
    let style = document.getElementById(styleId)
    if (!style) {
      style = document.createElement('style')
      style.id = styleId
      document.head.appendChild(style)
    }
    style.innerHTML = `
      .RaSidebar-paperAnchorLeft, .RaSidebar-paperAnchorDockedLeft {
        width: ${open ? '175px' : '0px'} !important;
      }
    `
  }, [open])

  return (
    <Sidebar {...props}>
      <MyMenu />
    </Sidebar>
  )
}

export default CustomSidebar
